module.exports = __webpack_public_path__ + "img/prev-button.cc7259c0.svg";